import { GridSeeker } from "ui-seeker/core"
import React, { useEffect } from "react"
import {formatNumber, postSubmit} from "ui-seeker/utils"
import { useAppCalendarSliderColor } from "./@hooks"

export default function AppCalendarSliderColor() {

    const { max, maxLabel, min, minLabel, onChange, value, setSlider, slider } = useAppCalendarSliderColor();

    const dragSlider = () => {
        const slide = document.querySelector(".SliderColor .slide"),
            sliderLeft = document.querySelector(".SliderColor .slide .pointMin"),
            sliderRight = document.querySelector(".SliderColor .slide .pointMax")

        let pos1 = 0, pos2 = 0, kind = 0;

        (sliderLeft || {}).onmousedown = (e) => {dragMouse(e); kind=1}
        (sliderRight || {}).onmousedown = (e) => {dragMouse(e); kind=2}

        function dragMouse(e) {
            e = e || window.event;e.preventDefault()
            pos2 = e.clientX
            document.onmouseup = closeDragElement
            document.onmousemove = elementDrag
        }

        function elementDrag(e) {
            e = e || window.event;e.preventDefault()
            pos1 = pos2 - e.clientX
            pos2 = e.clientX
            elementMove(pos1)
        }

        function elementMove(pos) {
            const slideWidth = parseInt(slide.offsetWidth)
            const currentMinWidth = parseInt(sliderLeft.offsetWidth)
            const currentMaxWidth = parseInt(sliderRight.offsetWidth)

            let newMinWidth = currentMinWidth
            let newMaxWidth = currentMaxWidth

            if (kind === 1) {
                newMinWidth = Math.max(0, Math.min(currentMinWidth - pos, slideWidth - currentMaxWidth))
            } else if (kind === 2) {
                newMaxWidth = Math.max(0, Math.min(currentMaxWidth + pos, slideWidth - currentMinWidth))
            }

            const minVal = min + (newMinWidth / slideWidth) * (max - min)
            const maxVal = min + ((slideWidth - newMaxWidth) / slideWidth) * (max - min)

            setSlider({
                minWidth: newMinWidth,
                maxWidth: newMaxWidth,
                value: [minVal, maxVal]
            })
        }

        function closeDragElement() {
            kind=0
            document.onmouseup = null
            document.onmousemove = null
            const minValue = sliderLeft.getAttribute('value')
            const maxValue = sliderRight.getAttribute('value')
            onChange([minValue, maxValue])
            postSubmit("/api/user-config/percentage-color/create", {"percentageLow": minValue, "percentageHigh": maxValue})
        }
    }

    useEffect(() => {
        const slide = document.querySelector(".SliderColor .slide")
        if (!slide) return

        const slideWidth = slide.offsetWidth
        const minPosition = ((value[0] - min) / (max - min)) * slideWidth
        const maxPosition = slideWidth - (((value[1] - min) / (max - min)) * slideWidth)

        setSlider({
            minWidth: minPosition,
            maxWidth: maxPosition,
            value: value
        })

        dragSlider()
    }, [value])
    return <GridSeeker container className="flex flex-center">
        <GridSeeker item size={6}>
            <div className="SliderColor">
            <div className="slide">
                <div className="pointMin" value={slider.value[0] || min} style={{width: slider.minWidth + 'px'}}>
                    <div className="label">{formatNumber(slider.value[0] || min, {decimals: 1})}%</div>
                </div>
                <div className="pointMax" value={slider.value[1] || max} style={{width: slider.maxWidth + 'px'}}>
                    <div className="label">{formatNumber(slider.value[1] || max, {decimals: 1})}%</div>
                </div>
            </div>
            <div className="labels">
                <div className="labelMin">{minLabel}</div>
                <div className="labelMax">{maxLabel}</div>
            </div>
        </div>
        </GridSeeker>
    </GridSeeker>
}